module.exports = __webpack_public_path__ + "static/media/qr.c0e2b35c.svg";